module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/menu-icon-content-ac5dc11cd78d04b0e115b261c9fcc440.png";